
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class extends Vue {
  @Prop({type: String, required: true})
  private readonly name!: string;

  @Prop({type: String})
  private readonly fill!: CSSStyleDeclaration['color'];
}
